import { render, staticRenderFns } from "./CardPagination.vue?vue&type=template&id=7ceb2ccf"
import script from "./CardPagination.vue?vue&type=script&lang=js"
export * from "./CardPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports